/* DO NOT FORGET to add export of this file to /src/store/reducers/index.js */
import * as FP from '../../utils/fp-js';

export const error = (state, action) =>
  FP.match(action.type)
    .on('SHOW_ERROR', action.payload)
    .on('HIDE_ERROR', '')
    .otherwise(state);
